import { createClient } from '@supabase/supabase-js'

/**
 * Supabase client — handles email/password auth, Google OAuth, and session
 * persistence. The same Supabase project that backs the FastAPI database is
 * reused for authentication, so user IDs are consistent end-to-end.
 *
 * Configure VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in `.env` from the
 * Supabase Dashboard → Project Settings → API.
 */
const url = import.meta.env.VITE_SUPABASE_URL
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

export const supabaseConfigured = Boolean(url && anonKey)

if (!supabaseConfigured) {
  // eslint-disable-next-line no-console
  console.warn(
    '[Radiance] Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY in .env. ' +
      'See .env.example. Authentication will fail until these are set.',
  )
}

export const supabase = createClient(
  url || 'https://placeholder.supabase.co',
  anonKey || 'placeholder-anon-key',
  {
    auth: {
      // Persist session in localStorage so refreshes don't kick the user out.
      persistSession: true,
      // Auto-refresh access tokens before they expire.
      autoRefreshToken: true,
      // After OAuth (Google) redirects back, Supabase reads the auth code from
      // the URL and exchanges it for a session.
      detectSessionInUrl: true,
      // PKCE is required for OAuth in single-page apps.
      flowType: 'pkce',
      storageKey: 'rd_supabase_session',
    },
  },
)
